import { appendState, setState } from '../../utils/redux.js';
import types from '../types.js';

const initialState = {
  selectedProject: null,
  projects: []
};

const projectReducer = (state = initialState, action) => {
  const {
    LOAD_PROJECTS,
    CREATE_PROJECT,
    SELECT_PROJECT,
    UPDATE_SELECTED_PROJECT,
    UPDATE_PROJECTS,
    SET_PROJECT_TABLES,
    CLEAR_PROJECT
  } = types;

  switch (action.type) {
    case CREATE_PROJECT:
      return appendState(state, 'projects', action.payload);
    case SELECT_PROJECT:
    case CLEAR_PROJECT:
    case UPDATE_SELECTED_PROJECT:
    case SET_PROJECT_TABLES:
      return setState(state, 'selectedProject', action.payload);
    case UPDATE_PROJECTS:
    case LOAD_PROJECTS:
      return setState(state, 'projects', action.payload);
    default:
      return state;
  }
};

export default projectReducer;
